import { useContext } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import surveys from './content'
import { Context } from '../../context'
import addIcon from '../../assets/icons/blue-add.svg'

const examplesCss = css`
  width: 240px;
  height: 150px;
  border: 1px solid #dde2e6;
  border-radius: 10px;
  margin-top: 35px;
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  position: relative;

  :hover {
    border-color: #4384f5;
  }

  .body {
    width: 100%;
    height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }

  .name {
    margin: 0 20px 15px 20px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 300;
  }

  .footer {
    width: 100%;
    height: calc(100% - 111px);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #d8dee5;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    transition: all 0.2s ease-in-out;
    background-color: white !important;

    .add {
      margin-right: 10px;
      margin-left: 10px;
      color: #3f8cff;
      display: flex;
      align-items: center;

      > img {
        color: #fff;
      }
    }

    .text {
      margin-top: 2px;
    }
  }

  .label {
    position: absolute;
    right: -10px;
    top: -10px;
    background-color: #4384f5;
    color: white;
    font-size: 10px;
    border-radius: 10px;
    padding: 5px 10px;
    font-weight: 500;
  }
`

const Templates = () => {
  const { setSandboxSurvey, redirectToSandbox, setIsTemplate } = useContext(
    Context
  )

  const openSandbox = (survey) => {
    setSandboxSurvey(survey.structure)
    redirectToSandbox()
    setIsTemplate(survey.slug)
  }

  if (!surveys || surveys.length <= 0) {
    return null
  }

  return surveys.map((survey) => (
    <div
      css={examplesCss}
      key={`template-${survey.slug}`}
      onClick={() => openSandbox(survey)}
    >
      <div className="label">NEW!</div>
      <div className="body">
        <span className="name">{survey.name}</span>
      </div>
      <div className="footer">
        <div className="add">
          <img src={addIcon} alt="add" />{' '}
          <span className="text">Add survey</span>
        </div>
      </div>
    </div>
  ))
}

export default Templates

{
  /*  otwieranie submit modala ⬇︎
  
  {isSubmitOpen && currentSurvey === survey.name && (
        <SubmitModal
          name={survey.name}
          survey={survey.structure}
          setIsOpen={(value) => {
            setSubmitOpen(value)
            setCurrentSurvey()
          }}
        />
      )} */
}
